import parse from "html-react-parser"
import { useTranslation } from "react-i18next"

import {
  DemoTranslatorBeforeAfter,
  DemoTranslatorUseCases,
} from "@/features/training/components/demo"
import { CourseLayout } from "@/features/training/components/layouts/course-layout"
import { CourseSection } from "@/features/training/components/layouts/course-section"

export function TranslatorUseCasesPage() {
  const { t } = useTranslation("", { keyPrefix: "training.ai-translator.use_cases" })

  return (
    <CourseLayout>
      <CourseSection>
        <h2>{t("main_title")}</h2>
        <p>{t("intro_text")}</p>
      </CourseSection>

      <CourseSection>
        <h3>{t("before_after_title")}</h3>
        <p>{t("before_after_intro")}</p>
        <div className="my-2">
          <DemoTranslatorBeforeAfter />
        </div>
      </CourseSection>

      <CourseSection>
        <h3>{t("categories_title")}</h3>
        <p>{t("categories_intro")}</p>
        <div className="my-2">
          <DemoTranslatorUseCases />
        </div>
      </CourseSection>

      <CourseSection>
        <h3>{t("walkthrough_title")}</h3>
        <p className="[&>a]:text-primary">{parse(t("report_example.description"))}</p>
        <div className="flex flex-col items-center justify-center gap-2 lg:flex-row">
          <img
            alt="PDF cover"
            className="my-2 w-full max-w-sm rounded-[6px]"
            src="/assets/training_images/ai-translator/1_pdf_cover_en.png"
          />
          <img
            alt="PDF footer"
            className="my-2 w-full max-w-md rounded-[6px]"
            src="/assets/training_images/ai-translator/1_pdf_footer_en.png"
          />
        </div>
        <p>{t("report_example.file_info")}</p>
        <img
          alt="Tokens"
          className="mx-auto my-2 w-full max-w-[150px] rounded-[6px]"
          src="/assets/training_images/ai-translator/2_tokens.png"
        />
        <p>{t("report_example.language_selection")}</p>
        <img
          alt="Language selection"
          className="mx-auto my-2 w-full max-w-[300px] rounded-[6px]"
          src="/assets/training_images/ai-translator/3_language_selection_en.png"
        />
        <p>{t("report_example.custom_translation")}</p>
        <img
          alt="Settings"
          className="mx-auto my-2 w-full max-w-[300px] rounded-[6px]"
          src="/assets/training_images/ai-translator/4_settings_en.png"
        />
        <p>{t("report_example.download_option")}</p>
        <img
          alt="Result"
          className="mx-auto my-2 w-full max-w-3xl rounded-[6px] border"
          src="/assets/training_images/ai-translator/5_result_en.png"
        />
      </CourseSection>
    </CourseLayout>
  )
}
